<template>
<div>

  <div v-if="item">
    <!-- <fields-list :item="item" :fields="fields" /> -->
        <h4>Входные данные</h4>
        <pre class="prettyprint"><code> {{item.data}} </code></pre>
        <hr/>
        <h4>Ответ</h4>
       <pre class="prettyprint"> <code> {{item.response}}  </code></pre>
  </div>
</div>

</template>
<script>
import { cardUpdate, cardContent } from "@/plugins/functions";

export default {

  data: () => ({
    cardLink: "logs",
    cardSetLink: "logs",
    item: null,
    fields: [
      
      ],
  }),
  props: ["id"],
  async created() {
    this.item = await this.cardContent(this.cardLink, this.id);
  },
  methods: {
    cardUpdate: cardUpdate,
    cardContent: cardContent,
    async updateItem() {
      let item = await this.cardUpdate(this.cardSetLink, this.item, this.fields);
    },
  },
};
</script>
<style>
</style>
